
export default {
    getProduct (id) {
        return env.API.get(`/product/${id}`, {
            baseURL: process.env['VUE_APP_MARKET_SERVICE_API_URL'],
        }).then( res => res.data );
    },

    getProducts() {
        return env.API.get(`/products/`, {
            baseURL: process.env['VUE_APP_MARKET_SERVICE_API_URL'],
        }).then( res => res.data );
    },

    buyProduct(pm, product_id, coupon) {
        return env.API.post(`/buy_product/`, {
                pm,
                product_id,
                coupon
            },
            {
                baseURL: process.env['VUE_APP_MARKET_SERVICE_API_URL'],
            }).then( res => res.data );
    },

    confirmTransaction(orderId) {
        return env.API.post(`/confirm_transaction/`, {
                order_id: orderId
            },
            {
                baseURL: process.env['VUE_APP_MARKET_SERVICE_API_URL'],
            }).then( res => res.data );
    }
}